
const getName = (typeID) => {
  if (typeID == '7dba0918-7cb1-11ea-bc55-0242ac130003') return 'Live';
  else if (typeID == '7148a87e-7cb1-11ea-bc55-0242ac130003') return 'VideoGallery';
  else if (typeID == '53303c9c-a75f-11eb-bcbc-0242ac130002') return 'MultiGallery';
  else if (typeID == '859c72c8-27b1-11eb-adc1-0242ac120002') return 'ActivityImage';
  else if (typeID == '98d761d0-8045-11eb-9439-0242ac130002') return 'Schedule';
  else if (typeID == '3fcebbe4-131a-11eb-adc1-0242ac120002') return 'SlotMachine';
  else if (typeID == 'a76a4826-7ced-11eb-9439-0242ac130002') return 'Timeline';
  else if (typeID == '6e2aec24-7cb1-11ea-bc55-0242ac130003') return 'Iframe'; // iFrame
  else if (typeID == 'bb624180-7ced-11eb-9439-0242ac130002') return 'Iframe'; // HTML
  else if (typeID == 'ae9c14ae-131a-11eb-adc1-0242ac120002') return 'Iframe'; // Jukebox
  else if (typeID == 'c06a3c8c-7ced-11eb-9439-0242ac130002') return 'UserProfile';
  else if (typeID == 'c43e7422-7ced-11eb-9439-0242ac130002') return 'Network';
  else if (typeID == '1ba329a8-131a-11eb-adc1-0242ac120002') return 'FoyerCategory';
  else if (typeID == 'dfb60b78-1fca-11eb-adc1-0242ac120002') return 'Foyer2D';
  else if (typeID == '6e4e4650-ea57-11eb-8921-ebe98f978e4f') return 'Areas';
  else if (typeID == '0693c7a8-1fcb-11eb-adc1-0242ac120002') return 'Foyer';
  else if (typeID == '4abe591a-131a-11eb-adc1-0242ac120002') return 'PhotoBooth';
  else if (typeID == 'ff47a4d0-c74c-11ec-9602-3f70bf3f767a') return 'AudioRecorder';
  else if (typeID == '00d65a70-afa3-11eb-8dc5-831f272eb4f1') return 'Trails';
  else if (typeID == 'e0608eb0-2a99-11ec-a0a1-8b5d8073a029') return 'Signature';
  else if (typeID == '781727ca-7cb1-11ea-bc55-0242ac130003') return 'Conference';
  else if (typeID == 'e049ffe0-4247-11ec-b589-1569dfa742bb') return 'Meta';
  else if (typeID == '02725ce6-36ab-11ec-8d3d-0242ac130003') return 'Live' // RouterCard
  else return 'Live'
}
export default { getName }

